<script>
import HelperTextPopup from 'dashboard/components/ui/HelperTextPopup.vue';

export default {
  components: {
    HelperTextPopup,
  },
  props: {
    title: { type: String, required: true },
    value: { type: [String, Number], default: '' },
    compact: { type: Boolean, default: false },
    description: { type: String, default: null },
  },
};
</script>

<template>
  <div class="overflow-auto" :class="compact ? 'py-0 px-0' : 'py-3 px-4'">
    <div class="items-center flex justify-between mb-1.5">
      <span
        class="w-full inline-flex gap-1.5 items-start font-medium whitespace-nowrap text-sm mb-0"
      >
        {{ title }}
        <HelperTextPopup
          v-if="description"
          :message="description"
          class="mt-0.5"
        />
      </span>
      <slot name="button" />
    </div>
    <div v-if="value" class="break-words">
      <slot>
        {{ value }}
      </slot>
    </div>
  </div>
</template>
